import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { SERIES_QUERY_KEY, removeShowFromSeries } from "./api";

interface RemoveShowFromSeriesParams {
  seriesId: string;
  showId: string;
  venuePageId: string;
}

/**
 * Hook to unassign a show from a series. The show row itself is not deleted.
 */
export function useRemoveShowFromSeries(): UseMutationResult<
  void,
  Error,
  RemoveShowFromSeriesParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ seriesId, showId }: RemoveShowFromSeriesParams) =>
      removeShowFromSeries(seriesId, showId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERIES_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
